import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiIconSvgComponent } from './eui-icon-svg.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiIconSvgComponent],
    declarations: [EuiIconSvgComponent],
})
export class EuiIconSvgModule {
}
